// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"x_sS h_jr h_fq h_ft h_fF h_z","menuItemSub":"x_sT h_dT h_fq h_fF","menuMainLink":"x_sV h_js h_hl","menuLink":"x_sW h_js h_hl","Link":"x_rs p_rs p_qG p_q0"};